<template>
  <!-- 专家库 -->
  <div class="box">
    <DetailsHead img="./img/bj4.png" title="专家库" remarks="Expert database" />

    <TopBreadcrumb :data="[
        { label: '数据开放', path: '/dataOpen/expertDatabase' },
        { label: '专家库', path: '/dataOpen/expertDatabase' },
        { label: '详情' },
      ]" />

    <div class="details-con" v-loading="loading">
      <div class="details-head">
        <div class="title">{{data.fullName}}</div>
        <div class="more">
          <!-- <div>有效日期	 : {{new Date(data.effectiveDate).formatCode()}} 来源 : 新华网</div> -->
            <div>【<span @click="$print()">打印</span>】 收藏 </div>
        </div>
      </div>
      <p class="title-name">专家信息：</p>
      <table cellspacing="0" cellpadding="0" border="0" width="100%" class="tb_job">
        <tbody>
          <tr>
            <td class="tdtit">姓名：</td>
            <td class="tdbox" colspan="5">{{data.fullName}}</td>
          </tr>
          <tr>
            <td class="tdtit">个人业绩：</td>
            <td class="tdbox" colspan="5">{{data.individualPerformance}}</td>
          </tr>
          <tr>
            <td class="tdtit">职位：</td>
            <td class="tdbox" colspan="5">{{data.jobTitle}}</td>
          </tr>
          <tr>
            <td class="tdtit">专业：</td>
            <td class="tdbox" colspan="5">{{data.major}}</td>
          </tr>
          <tr>
            <td class="tdtit">照片：</td>
            <td class="tdbox" colspan="5">
              <img :src="data.photo" alt="">
            </td>
          </tr>
          <tr>
            <td class="tdtit">个人简历：</td>
            <td class="tdbox content" colspan="5">
              <p class="content-box" v-html="data.resume"></p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { fileName } from "@/utils";
import TopBreadcrumb from "@/components/TopBreadcrumb.vue";
import DetailsHead from "@/components/DetailsHead.vue";
import { expert } from "@/api/dataOpen.js";
const { getDocumentDetails } = expert;
export default {
  components: { DetailsHead, TopBreadcrumb },
  data() {
    return {
      fileName,
      loading: false,
      data: {},
    };
  },
  mounted() {
    this.loading = true;
    getDocumentDetails(this.$route.params.id)
      .then((res) => {
        this.data = res.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style lang="less" scoped>
@import url("../../assets/less/details-box.less");

.title-name {
  display: block;
  margin-top: 10px;
  font-size: 17px;
  color: #333;
  text-align: left;
  width: 100%;
  padding: 10px;
}
.tb_job {
  line-height: 50px;
  background: #a6dcf6;
}
.tb_job td {
  padding: 3px 8px;
  background: #ffffff;
}
.tb_job td h1 {
  text-align: left;
}
.tb_job .tdtit {
  padding: 3px 8px;
  width: 15%;
  font-size: 12px;
  color: #666;
  text-align: right;
  background: #e3f5ff;
  border: 1px solid #a6dcf6;
}
.tb_job .tdbox {
  padding: 3px 8px;
  font-family: "Arial";
  border: 1px solid #a6dcf6;
}
.tb_job .tdbox.content p {
  line-height: 37px;
  // 处理换行
  white-space: pre-wrap;
}
.tb_job .tdtit strong {
  color: #2096db;
}
.tb_job img{
  max-width: 800px;
  max-height: 500px;
}
</style>